import React from "react";
import PropTypes from "prop-types";

import * as types from "../../../constants/ComponentConstants";

import Form from "../../common/Form";
import Section from "../../common/Section";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";
import CheckBoxWithChild from "../../common/CheckBoxWithChild";

const DoelgroepenForm = (props) => {
    const {
        models,
        onChange,
        onSave,
        disabled,
        onUndo,
        undoButtonDisabled
    } = props;

    const doelgroepen = models.map((doelgroep, i) => {
        return (
            <CheckBoxWithChild disabled={disabled} key={i} name={"checked_" + i} value={doelgroep.checked} label={doelgroep.naam} onChange={onChange} size={6} />
        );
    });

    return (
        <Section title="Doelgroepen" color={types.COLOR_PINK_LIGHT}>
            <Form name="doegroepen"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Bewaar"
                onRightButtonClick={onSave}
                rightButtonDisabled={disabled}
                onUndoButtonClick={onUndo}
                undoButtonVisible={!undoButtonDisabled}
            >
                <Fieldset>
                    <Row>
                        {doelgroepen}
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

DoelgroepenForm.propTypes = {
    models: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    onUndo: PropTypes.func,
    undoButtonDisabled: PropTypes.bool
};

export default DoelgroepenForm;